import React from 'react'

import { motion } from 'motion/react'
import { Heading } from '@grammarly/design-system'

import { ANIMATED_LAYOUT } from '../constants'
import type { IconRenderFunction } from '../types'
import { useLayoutTransition } from '../../animation/hooks/useLayoutTransition'
import classes from './HeaderTitle.module.scss'

export type HeaderTitleProps = {
  title: string
  renderIcon: IconRenderFunction
  isExpanded: boolean
}

export const HeaderTitle: React.FC<HeaderTitleProps> = ({ title, renderIcon, isExpanded }) => {
  const transition = useLayoutTransition()

  return (
    <motion.div
      layout
      transition={transition}
      style={ANIMATED_LAYOUT.title(isExpanded)}
      className={!isExpanded ? classes.title : undefined}
    >
      <motion.div layout style={{ width: 'fit-content', display: 'flex' }} transition={transition}>
        {renderIcon({ size: isExpanded ? 'xlarge' : 'medium' })}
      </motion.div>
      <motion.div layout style={{ width: 'fit-content', margin: 0 }} transition={transition}>
        <Heading
          as="h1"
          style={{
            fontSize: isExpanded ? '1.25rem' : '0.875rem',
            fontWeight: isExpanded ? 600 : 400,
            margin: 0,
          }}
          variant="heading-small"
        >
          {title}
        </Heading>
      </motion.div>
    </motion.div>
  )
}
